import {
  Box,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Theme,
  Tooltip,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useApi } from "../../../api/use-api";
import { usersList } from "../../../api/users/users";
import { makeStyles } from "@mui/styles";
import { Button } from "../../../components/button/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import useScreenSize from "../../../utils/use-screen";
import { Link } from "react-router-dom";
import { Error, HistoryEdu, Save } from "@mui/icons-material";

const CELLS = [
  "UId",
  "AId",
  "first",
  "last",
  "A counts",
  "email",
  "phone number",
  "status",
  "created at",
  "enter code",
  "logs",
  "errors",
  "files",
];

export const Users: FC = () => {
  const { api: userListApi, data: users } = useApi(usersList);

  const { isDesktop } = useScreenSize();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(15);

  const classes = useClass();

  const { values, errors, handleSubmit, handleChange, setFieldValue } =
    useFormik({
      validationSchema: Yup.object({
        email: Yup.string().email(),
        phoneNumber: Yup.string(),
        accountId: Yup.string(),
        userId: Yup.string(),
        date: Yup.string(),
        firstName: Yup.string(),
        lastName: Yup.string(),
      }),
      initialValues: {
        phoneNumber: "",
        email: "",
        accountId: "",
        userId: "",
        date: "",
        firstName: "",
        lastName: "",
      },
      onSubmit: (data) => {
        userListApi({
          skip: page * limit,
          limit: limit,
          ...data,
        });
      },
    });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accountId = urlParams.get("accountId");

    userListApi({
      skip: 0,
      limit: 15,
      ...(accountId ? { accountId } : {}),
    });
    if (accountId) {
      setFieldValue("accountId", accountId);
    }
  }, [userListApi, setFieldValue]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box component="form" m={1} onSubmit={handleSubmit}>
        <TextField
          size="small"
          id="accountId"
          name="accountId"
          placeholder="accountId"
          value={values.accountId}
          error={!!errors.accountId}
          onChange={handleChange}
          className={classes.inputs}
        />
        <TextField
          size="small"
          id="firstName"
          name="firstName"
          placeholder="first name"
          value={values.firstName}
          className={classes.inputs}
          onChange={handleChange}
          error={!!errors.firstName}
        />
        <TextField
          size="small"
          id="lastName"
          name="lastName"
          placeholder="last name"
          value={values.lastName}
          onChange={handleChange}
          error={!!errors.lastName}
          className={classes.inputs}
        />
        <TextField
          size="small"
          id="email"
          name="email"
          placeholder="email"
          value={values.email}
          error={!!errors.email}
          onChange={handleChange}
          className={classes.inputs}
        />
        <TextField
          size="small"
          id="phoneNumber"
          name="phoneNumber"
          placeholder="phone number"
          className={classes.inputs}
          value={values.phoneNumber}
          onChange={handleChange}
          error={!!errors.phoneNumber}
        />
        <TextField
          size="small"
          id="date"
          name="date"
          placeholder="date"
          value={values.date}
          error={!!errors.date}
          onChange={handleChange}
          className={classes.inputs}
        />
        <Button variant="outlined" type="submit">
          submit
        </Button>
      </Box>
      <Paper
        component={Grid}
        width={isDesktop ? "80vw" : "100vw"}
        overflow={"scroll"}
      >
        <TableContainer>
          <Table aria-labelledby="tableTitle" size={"small"}>
            <TableHead>
              <TableRow>
                {CELLS.map((item) => (
                  <TableCell key={item}>{item}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {users?.list.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    <Tooltip title={item.id}>
                      <span>{item.id.slice(-8)}</span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <Tooltip
                      title={
                        item.accounts && item.accounts[0] && item.accounts[0].id
                      }
                    >
                      <span>
                        {item.accounts &&
                          item.accounts[0] &&
                          item.accounts[0].id.slice(-8)}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    {item.accounts &&
                      item.accounts[0] &&
                      item.accounts[0].firstName}
                  </TableCell>
                  <TableCell>
                    {item.accounts &&
                      item.accounts[0] &&
                      item.accounts[0].lastName}
                  </TableCell>
                  <TableCell>{item.accounts && item.accounts.length}</TableCell>
                  <TableCell>{item.email}</TableCell>
                  <TableCell>{item.phoneNumber}</TableCell>
                  <TableCell>
                    {item.accounts &&
                      item.accounts[0] &&
                      item.accounts[0].status}
                  </TableCell>
                  <TableCell>
                    {item.createdAt.slice(0, 19).replace("T", " , ")}
                  </TableCell>
                  <TableCell>{item.enterCode}</TableCell>
                  <TableCell>
                    <Link
                      to={`/app/logs?accountId=${item.accounts && item.accounts[0] && item.accounts[0].id}`}
                    >
                      <IconButton>
                        <HistoryEdu />
                      </IconButton>
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/app/errors?accountId=${item.accounts && item.accounts[0] && item.accounts[0].id}`}
                    >
                      <IconButton>
                        <Error />
                      </IconButton>
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/app/files?accountId=${item.accounts && item.accounts[0] && item.accounts[0].id}`}
                    >
                      <IconButton>
                        <Save />
                      </IconButton>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[15, 30, 60, 100, 200, 500, 1000]}
          count={users?.count || 0}
          rowsPerPage={limit}
          page={page}
          onPageChange={(_, page) => {
            userListApi({
              skip: page * limit,
              limit: limit,
            });
            setPage(page);
          }}
          onRowsPerPageChange={(e) => {
            setLimit(parseInt(e.target.value));
            userListApi({
              skip: page * parseInt(e.target.value),
              limit: parseInt(e.target.value),
            });
          }}
        />
      </Paper>
    </Box>
  );
};

const useClass = makeStyles((theme: Theme) => ({
  inputs: {
    margin: `${theme.spacing(0, 0.5)} !important`,
  },
}));
